// Detect that value is changing outside the change event loop of the component
export default {
	data() {
		return {
			updating: false,
			valueName: 'value',
			changeHandlerName: 'handleChange'
		};
	},
	mounted() {
		if (!Array.isArray(this.valueName))
			this.valueName = [this.valueName];

		this.valueName.forEach(valueName => {
			this.$watch(valueName, function() {
				if (!this.updating)
					this.resetData();
				else
					this.updating = false;
			});
		});

		if (typeof this.changeHandlerName === 'string') {
			const componentChange = this[this.changeHandlerName];
			this[this.changeHandlerName] = (value, ev) => {
				this.updating = true;
				componentChange(value, ev);
			};
		}
		else
			this.changeHandlerName.forEach(handlerName => {
				const componentChange = this[handlerName];
				this[handlerName] = (value, ev) => {
					this.updating = true;
					componentChange(value, ev);
				};
			});
	},
	updated() {
		this.updating = false;
	},
	methods: {
		addResetDataCallback(callback) {
			this.$on('reset-data', callback);
		},
		resetData() {
			Object.assign(this.$data, this.$options.data.apply(this));
			this.$emit('reset-data');
		}
	}
};